import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/Security",
    name: "Security",
    component: () => import("../views/Security.vue"),
  },
  {
    path: "/DataBoard",
    name: "DataBoard",
    component: () => import("../views/DataBoard.vue"),
  },
  {
    path: "/BuildingData",
    name: "BuildingData",
    component: () => import("../views/BuildingData.vue"),
  },
];

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

export default router;
